// import { Form } from '@ant-design/compatible';
import { Collapse, Select, Form, Button, message } from "antd";
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { union } from "lodash";
import Breadcrumb from "../../../components/Breadcrumb";
import {
  applicationsGetAll,
  indexesGetAllIndexes,
  applicationGetDefaultConfig,
  applicationSetDefaultPermission,
} from "../../../store/actions/index";
import { sortBy } from "lodash";
import ConfigSet from "./ConfigSet";
import {
  getDefaultConfigElement,
  preprocessRecord,
  ENABLED_APPS,
  // ,getConfigs
} from "../../Project/AppConfiguration";

import {
  validateQMS,
  validateULP,
} from "../../../components/Project/AppConfiguration/index";

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
    md: { span: 8 },
    lg: { span: 6 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
    md: { span: 12 },
    lg: { span: 10 },
  },
  style: { marginBottom: 8 },
};

const buttonStyles = {
  // labelCol: { xs:{span:24},sm:{span:8},md:{span:8},lg:{span:6} },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16, offset: 8 },
    md: { span: 12, offset: 8 },
    lg: { span: 10, offset: 6 },
  },
  style: { marginBottom: 8 },
};

export class DefaultPermissions extends Component {
  // static propTypes = {
  //     prop: PropTypes
  // }
  constructor(props) {
    super(props);

    this.state = {
      allIndexes: [],
      allApps: [],
      selectedApp: undefined,
      setconfig: {},
      validate: {},
    };
  }

  componentDidMount = async () => {
    const dataset = await this.props.applicationsGetAll();
    const indexes = await this.props.indexesGetAllIndexes();
    this.setState({
      allApps: dataset,
      allIndexes: !indexes.error ? indexes.data : [],
    });
    // console.log(dataset,'dataset')
  };

  updateSelectedApp = async (value) => {
    const data = await this.props.applicationGetDefaultConfig(value);

    let setconfig = getDefaultConfigElement(this.getSelectedAppName(value));
    const selectedApp = this.getSelectedApp(value);
    const indexIds = this.state.allIndexes.map((el) => el._id);
    // console.log(setconfig,'set 1')

    if (data?.default_config) {
      setconfig = {
        ...setconfig,
        ...data.default_config,
      };
      // console.log(data.application,,'app config datase')
    }
    if (selectedApp !== undefined) {
      preprocessRecord(indexIds, selectedApp, setconfig);
    }
    // console.log(setconfig,'setconfig')

    this.setState({ selectedApp: value, app_config: setconfig });
  };

  updateValue = (value, _id, key1) => {
    const appElm = this.state.allApps.find((el) => el._id === _id);

    if (this.state.app_config !== undefined && appElm !== undefined) {
      const configSet = { ...this.state.app_config };
      configSet[key1] = value;

      if (
        appElm.app_name === "ULP" &&
        (key1 === "mandatory_indexes" || key1 === "searchable_indexes") &&
        Array.isArray(configSet.required_indexes)
      ) {
        const validinds = union(
          configSet.mandatory_indexes,
          configSet.searchable_indexes
        );
        configSet.required_indexes = [
          ...configSet.required_indexes.filter((kl) => {
            return validinds.includes(kl);
          }),
        ];
      }
      if (
        appElm.app_name === "Compliance" &&
        key1 === "searchable_indexes" &&
        Array.isArray(configSet.alternate_searchable_indexes)
      ) {
        const validinds = Array.isArray(configSet.searchable_indexes)
          ? configSet.searchable_indexes
          : [];
        configSet.alternate_searchable_indexes = [
          ...configSet.alternate_searchable_indexes.filter((kl) => {
            return !validinds.includes(kl);
          }),
        ];
      }
      this.setState({ app_config: configSet });
    }
  };

  validate = async () => {
    const validated = {};
    let returnval = true;
    if (this.getSelectedAppName(this.state.selectedApp) === "QMS") {
      validateQMS(this.state.app_config, validated);
    } else if (this.getSelectedAppName(this.state.selectedApp) === "ULP") {
      validateULP(this.state.app_config, validated);
    }

    Object.keys(validated).forEach((key) => {
      if (validated[key]) {
        returnval = false;
      }
    });

    if (!returnval) {
      message.error("Please fix all errors");
    }

    const updated = await new Promise((resolve) => {
      this.setState(
        {
          validate: validated,
        },
        () => {
          resolve(true);
        }
      );
    });
    return returnval;
  };

  getSelectedApp = (id) => {
    if (typeof id === "string") {
      const selectedApp = this.state.allApps.find((el) => el._id === id);
      return selectedApp !== undefined ? selectedApp : undefined;
    }
    return undefined;
  };

  getSelectedAppName = (id) => {
    const selectedapp = this.getSelectedApp(id);
    return selectedapp !== undefined ? selectedapp.app_name : "";
  };

  submitHandler = async () => {
    const validateres = await this.validate();
    if (validateres) {
      const result = await this.props.applicationSetDefaultPermission(
        this.state.selectedApp,
        this.state.app_config
      );
    }
  };

  render() {
    return (
      <Fragment>
        <div className="container_aa">
          <h3>Default App Settings</h3>
          <Breadcrumb
            routes={[
              { path: "/", breadcrumbName: "Dashboard" },
              {
                path: "/applications/default",
                breadcrumbName: "Default App Settings",
              },
            ]}
          ></Breadcrumb>
        </div>
        <div className="container_ab">
          <Fragment>
            <Form.Item {...formItemLayout} label="Application">
              <Select
                placeholder="Select Application"
                style={{ width: "100%", maxWidth: 400 }}
                value={this.state.selectedApp}
                onChange={this.updateSelectedApp}
                showSearch={true}
                filterOption={(input, option) => {
                  return (
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  );
                }}
              >
                {this.state.allApps.map((el) => (
                  <Select.Option
                    value={el._id}
                    key={el._id}
                    disabled={!ENABLED_APPS.includes(el.app_name)}
                  >
                    {el.app_name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Collapse defaultActiveKey={["1"]} expandIconPosition="end">
              <ConfigSet
                type={this.getSelectedAppName(this.state.selectedApp)}
                app_id={this.state.selectedApp}
                config={this.state.app_config}
                indexes={this.state.allIndexes}
                updateValue={this.updateValue}
                validate={this.state.validate}
              />
            </Collapse>
            {typeof this.state.app_config === "object" &&
            Object.keys(this.state.app_config).length > 0 ? (
              <Form.Item {...buttonStyles}>
                <Button type="primary" onClick={this.submitHandler}>
                  Update
                </Button>
              </Form.Item>
            ) : null}
          </Fragment>
        </div>
      </Fragment>
      // <div>
      //     this is class component{this.state.test}
      // </div>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  applicationsGetAll: () => dispatch(applicationsGetAll()),
  indexesGetAllIndexes: () => dispatch(indexesGetAllIndexes()),
  applicationGetDefaultConfig: (id) =>
    dispatch(applicationGetDefaultConfig(id)),
  applicationSetDefaultPermission: (id, config) =>
    dispatch(applicationSetDefaultPermission(id, config)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DefaultPermissions);
